/** Avoid duplicate brand name when line equals or repeats brand (e.g. "Arturo Fuente Arturo Fuente"). */
export function formatCigarTitle(brandName: string, lineName: string): string {
  const brand = brandName.trim()
  const line = lineName.trim()
  if (!line) return brand
  if (line.toLowerCase() === brand.toLowerCase()) return brand
  if (line.toLowerCase().startsWith(`${brand.toLowerCase()} `)) return line
  return `${brand} ${line}`
}

/** Returns the humidor label for display. */
export function formatHumidorLabel(name: string): string {
  return name.trim()
}
